let ol = require('openlayers');
let jsts = require('jsts/dist/jsts');
let parser = new jsts.io.OL3Parser(undefined, ol);

let AbstractOperation = require('../operations/abstract');
let IsDisjointedResult = require('../operations/types/isDisjointedResult');


/**
 * Класс IsDisjointed
 * @extends AbstractOperation
 */
class IsDisjointed extends AbstractOperation {

    /**
     * Создает экземпляр класса IsDisjointed
     */
  constructor() {
    super()
  }


    /**
     *
     * @param featureA
     * @param featureB
     * @return {boolean}
     */
    execute(featureA, featureB) {
        let isDisjointed = operation(featureA, featureB);

        return new IsDisjointedResult({
            result: isDisjointed
        })
    }
    }

function operation(featureA, featureB) {
    let geomA = parser.read(featureA.getGeometry());
    let geomB = parser.read(featureB.getGeometry());
    let result = geomA.disjoint(geomB);
    return result
}



module.exports = IsDisjointed;